import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import InputField from "../../components/InputField";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import Modal from "../../components/Modal";
import { useAuth } from "../../providers/AuthContext";
import { getIndexAdjustmentsByAgreement } from "../../api/BillingGroups";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import IndexAdjustmentForm from "../../components/indexadjustment/IndexAdjustmentForm";
import Breadcrumbs from "../../components/Breadcrumbs";

const EditIndexAdjustmentPage = () => {
  const { getAccessToken } = useAuth();
  const { agreementPublicId, indexAdjustmentPublicId } = useParams();
  const navigate = useNavigate();
  const [indexAdjustment, setIndexAdjustment] = useState(null);
  const [loadingIndexAdjustment, setLoadingIndexAdjustment] = useState(true);
  const [hasChanges, setHasChanges] = useState(false);
  const [confirmState, setConfirmState] = useState({ isOpen: false, id: "" });
  const [billingGroups, setBillingGroups] = useState([]);

  useEffect(() => {
    handleGetIndexAdjustments();
  }, [agreementPublicId, indexAdjustmentPublicId]);

  const handleGetIndexAdjustments = async () => {
    try {
      const accessToken = await getAccessToken();

      const indexAdjustments = await getIndexAdjustmentsByAgreement(
        agreementPublicId,
        accessToken
      );

      const selectedIndexAdjustment = indexAdjustments.find(
        (adj) => adj.indexAdjustmentPublicId === indexAdjustmentPublicId
      );

      if (!selectedIndexAdjustment) {
        console.error(
          "No index adjustment found for ID:",
          indexAdjustmentPublicId
        );
        toast.error("Index adjustment not found.");
        return;
      }

      setIndexAdjustment(selectedIndexAdjustment);
      setLoadingIndexAdjustment(false);
    } catch (error) {
      setLoadingIndexAdjustment(false);
      toast.error("Failed to load index adjustment data.");
    }
  };

  /*   const handleGetBillingGroups = async () => {
    try {
      const accessToken = await getAccessToken();
      const groups = await getBillingGroupsByUser(userPublicId, accessToken);
      setBillingGroups(groups);
    } catch (error) {
      console.error("Failed to fetch billing groups:", error);
    }
  }; */

  const handleBackClick = () => {
    if (hasChanges) {
      setConfirmState((s) => ({
        ...s,
        isOpen: true,
        title: "Discard changes?",
        confirm: () => {
          navigate(-1);
        },
      }));
    } else {
      navigate(-1);
    }
  };

  /*   const handleBillingGroupChange = (option) => {
    const selectedGroup = billingGroups.find(group => group.name === option);
    if (!selectedGroup) return;  
    setIndexAdjustment((prevIndexAdjustment) => ({
      ...prevIndexAdjustment,
      billingGroupName: selectedGroup.name,
      billingGroupPublicId: selectedGroup.billingGroupPublicId
    }));
    setHasChanges(true);
  }; */

  /*   const handleUpdateIndexAdjustment = async () => {
    try {
      const accessToken = await getAccessToken();
      
      // Update the billing group first (if it has changed)
      if (indexAdjustment.billingGroupPublicId) {
        const updatedIndexAdjustment = await updateBillingGroupOnIndexAdjustment(indexAdjustment.billingGroupPublicId, indexAdjustment.indexAdjustmentPublicId, accessToken);
        setIndexAdjustment(updatedIndexAdjustment); // Update the user state with the new data
      }
      
      setHasChanges(false); // Reset change state
      toast.success("IndexAdjustment updated successfully"); // Show success message
    } catch (error) {
      console.error("Failed to update indexAdjustment:", error);
      toast.error("Failed to update indexAdjustment");
    }
  }; */

  const saveAndExit = () => {
    /*     handleUpdateIndexAdjustment();
     */
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute w-full pointer-events-none">
            <LoadingTablePage
              title={"IndexAdjustments"}
              loading={loadingIndexAdjustment}
            />
          </div>
          <div
            className={`${
              loadingIndexAdjustment ? "loading" : ""
            } page-content`}
          >
            <Breadcrumbs />

            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">
                {agreementPublicId !== "0"
                  ? "Edit index adjustment"
                  : "Create Index adjustment"}
              </h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick={saveAndExit}
                >
                  Update
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <IndexAdjustmentForm
                indexAdjustment={indexAdjustment || {}}
                setIndexAdjustment={setIndexAdjustment}
                setHasChanges={setHasChanges}
                disabled={true}
                billingGroups={billingGroups}
                /*                 onBillingGroupChange={handleBillingGroupChange}
                 */
              />
            </div>
          </div>
        </main>
        <ConfirmationModal
          isOpen={confirmState.isOpen}
          title={confirmState.title ? confirmState.title : "Discard changes?"}
          onClose={() => {
            setConfirmState((s) => ({ ...s, isOpen: false }));
          }}
          onConfirm={() => {
            setConfirmState((s) => ({ ...s, isOpen: false }));
            confirmState.confirm();
          }}
        />
      </div>
    </>
  );
};

export default EditIndexAdjustmentPage;
